import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from "react-router-dom";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    outline:' none',
    borderRadius: '4px',
    bgcolor: 'background.paper',
    p: 4,
  };

const RemainderModal = ( { open,setOpen } ) => {
    const navigate = useNavigate();
    
  return (
    <Modal
    open={open}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box sx={style}>
      <Typography id="modal-modal-title" variant="h4" component="h2">
        <FormattedMessage id = "Reminder" />
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        <FormattedMessage id = "remaindertext" />
      </Typography>
      <Box display = "flex" justifyContent = "space-between" mt = {2.5}>
      <Button onClick={() => { localStorage.removeItem('urlPart'); setOpen(false); }} variant="contained" startIcon={<CloseIcon />}><FormattedMessage id = "Close" /></Button>
      <Button onClick = {() => { navigate(`create-patient/${localStorage.getItem('urlPart')}`); setOpen(false); }} variant="contained" endIcon={<ArrowRightIcon />}><FormattedMessage id = "Continue" /></Button>
      </Box>
    </Box>
  </Modal>
  )
}

export default RemainderModal